import { PasswordRulesServerData } from '../userConfig'

export enum AuthServiceErrorCode {
  GENERAL,
  UNAUTHORIZED,
}

export enum LoginErrorCode {
  ERR_INVALID_USER_PASS,
  ERR_USER_LOCKED,
  ERR_INVALID_OTP,
  ERR_INVALID_SMS_OTP,
  ERR_SMSOTP_LIMITED,
  ERR_INVALID_OTP_HASH,
  ERR_CLOSE_DAY_RUNNING,
  ERR_IP_ACCESS_DENIED,
  ERR_LOGIN_FAILED,
  ERR_HASH_EXPIRED,
  ERR_INVALID_HASH,
  ERR_USER_WEB_ACCESS_DENIED,
  ERR_USER_PASSWORD_EXPIRED_CHANGE,
  LOGIN_SMS_OTP,
  MSG_SMS_OTP_SENT,
  UNKNOWN, // custom error
  ERR_INVALID_USER_PHONE,
  ERR_INVALID_USER_PHONE_CODE,
}

export interface LoginFailure {
  message: LoginErrorCode | 'HINT_ERR_TITLE'
  passwordRules?: PasswordRulesServerData
}

export interface LoginResult {
  STK: string
  OTPHash: string
  OTPHashExpire: number
  STKExpire: number
  DisplayToken: string
  ServerName: string
  Database: string
  PassExpire: PasswordState
  PassRules: PasswordRulesServerData
}

export enum PasswordState {
  Okay = -1,
  Expired = 0,
}

export enum PasswordChangeErrorCodes {
  ERR_INVALID_USER_PHONE,
  ERR_INVALID_USER_PHONE_CODE,
  ERR_INVALID_USER_PASS,
}

export interface UserVerifyFailure {
  message: PasswordChangeErrorCodes | string
}

export interface PasswordResetFailure {
  message: PasswordChangeErrorCodes | string
}

export type ValidatePasswordRules = {
  MinLength: number
  PassHistoryCount: number
  UpperCase: number
  LowerCase: number
  Numbers: number
  Specials1: number
  Specials2: number
  SpecialChars1: string
  SpecialChars2: string
}

export type UserVerifyResult = {
  PassRules: ValidatePasswordRules
}

export type UserPasswordChange = {
  success: true
}
